const NAME = 'MATOMO';
const CNameMapping = {
  [NAME]: NAME,
  Matomo: NAME,
  matomo: NAME,
};

export { NAME, CNameMapping };
